export default {
  getQuoteRequest({ id }) {
    return {
      method: 'GET',
      url: `transporter/quoteRequest/${id}`,
    };
  },
  getMatchedRequests({ params }) {
    return {
      method: 'get',
      url: 'transporter/quoteRequest/matched',
      params,
    };
  },
  getBookedRequests({ params }) {
    return {
      method: 'GET',
      url: 'transporter/quoteRequest/booked',
      params,
    };
  },
  denyRequest({ id }) {
    return {
      method: 'POST',
      url: `transporter/quoteRequest/${id}/deny`,
    };
  },
  getPendingResponses(params) {
    return {
      method: 'get',
      url: 'transporter/quoteResponse/pending',
      params,
    };
  },
  getProfile() {
    return {
      method: 'GET',
      url: 'transporter/profile',
    };
  },
  updateProfile(data) {
    return {
      method: 'PUT',
      url: 'transporter/profile',
      data,
    };
  },
  updateProfilePhoto(companyLogo) {
    return {
      method: 'PUT',
      url: 'transporter/profile/photo',
      data: {
        companyLogo,
      },
    };
  },
  getConversations({ page, perPage }) {
    return {
      method: 'get',
      url: 'transporter/bookingConversation',
      params: {
        page,
        perPage,
      },
    };
  },
  getSetupIntent() {
    return {
      method: 'GET',
      url: 'company/profile/payment/setup-intent',
    };
  },
  getTransporterPayment() {
    return {
      method: 'GET',
      url: 'company/profile/payment',
    };
  },
  createTransporterPayment(data) {
    return {
      method: 'POST',
      url: 'company/profile/payment',
      data,
    };
  },
  updateTransporterPayment(data) {
    return {
      method: 'PUT',
      url: 'company/profile/payment',
      data,
    };
  },
  updateQuoteTemplate(companyLogo) {
    return {
      method: 'PUT',
      url: 'company/quote-template',
      data: { companyLogo },
    };
  },
  getUsers(params) {
    return {
      method: 'get',
      url: 'transporter/users',
      params,
    };
  },
  deleteUser({ userId }) {
    return {
      method: 'delete',
      url: `users/${userId}`,
    };
  },
  updateRoles({ userId, role }) {
    return {
      method: 'PATCH',
      url: `users/${userId}/role`,
      data: { role },
    };
  },
  sendInvitations({ emails, role }) {
    return {
      method: 'post',
      url: 'transporter/invitations',
      data: {
        emails,
        role,
      },
    };
  },

  getRoles() {
    return {
      method: 'get',
      url: 'transporter/roles',
    };
  },
};
